import angular from "angular";
//import contract from "../../Contract";
import { vsModuleName as configModuleName } from "./configs/module";
import { vsModuleName as sharedModuleName } from "../shared";
import {
  MachinesComponentsViewsMain,
  vsComponentName as MachinesComponentsViewsMainName,
} from "./components/views/main/component";
import { routeConfig } from "./routes";
import {
  CloneAndConversionService,
  vsServiceName as CloneAndConversionServiceName,
} from "./services/cloneAndConversionService";
import {
  MachineConfigurationViewDetailComponentOptions,
  vsComponentName as MachineConfigurationViewComponentName,
} from "./components/machineConfigurationDetailView/component";
import {
  machinesMoveViewComponentOptions,
  vsComponentName as machinesMoveViewComponentName,
} from "./components/views/main/move";
import {
  machinesWarehouseMoveViewComponentOptions,
  vsComponentName as machinesWarehouseMoveViewComponentName,
} from "./components/views/main/warehouse";
import {
  machinesDecommissionMoveViewComponentOptions,
  vsComponentName as machinesDecommissionMoveViewComponentName,
} from "./components/views/main/decommission";
import {
  singleMachineMoveComponentOptions,
  vsComponentName as singleMachineMoveComponentName,
} from "./components/views/detail/move/component";
import {
  singleMachineWarehouseComponentOptions,
  vsComponentName as singleMachineWarehouseComponentName,
} from "./components/views/detail/warehouse";
import {
  singleMachineDecommissionComponentOptions,
  vsComponentName as singleMachineDecommissionComponentName,
} from "./components/views/detail/decommission";
import {
  SlotTrakServerAdapter,
  vsName as SlotTrakServerAdapterName,
} from "./slotTrakServerAdapter";
import {
  vsComponentName as machineDetailSpecificComponentName,
  machineDetailSpecificComponentOptions,
} from "./components/views/detail";
import { vsModuleName as partsMachinesModuleName } from "../../parts.machines/module";
import {
  MachineConfigurationTypeDetailViewComponentOptions,
  vsComponentName as MachineConfigurationTypeDetailViewComponentName,
} from "./components/machineConfigurationTypeDetailView";
import {
  machineConfigurationTypeInfoComponentOptions,
  vsComponentName as machineConfigurationTypeInfoComponentName,
} from "./components/views/configurationType/info";
import {
  machineConfigurationTypeInfoGamesComponentOptions,
  vsComponentName as machineConfigurationTypeInfoGamesComponentName,
} from "./components/views/configurationType/info/games/component";
import {
  machineConfigurationTypeDetailGameViewComponentOptions,
  vsComponentName as machineConfigurationTypeDetailGameViewComponentName,
} from "./components/machineConfigurationTypeDetailView/machineConfigurationTypeGameDetailView";
import {
  machineProgressiveGameDetailViewComponentOptions,
  vsComponentName as machineProgressiveGameDetailViewComponentName,
} from "./components/machineConfigurationTypeDetailView/machineProgressiveGameDetailView";
import {
  machineConfigurationTypeInfoProgressiveGamesComponentOptions,
  vsComponentName as machineConfigurationTypeInfoProgressiveGamesComponentName,
} from "./components/views/configurationType/info/progressiveGames/component";
import {
  GratonUtilsService,
  vsServiceName as GratonUtilsServiceName,
} from "./utils";
import { vsName as DepreciationModuleName } from "../../Depreciation";
import { vsModuleName as changeJournalModuleName } from "../../records/changeJournal/module";


export const vsModuleName = "SlotTrak.Machines";
export const vsClientName = "graton";
export default vsModuleName;

angular
  .module(vsModuleName, [
    configModuleName,
    sharedModuleName,
    partsMachinesModuleName,
    //contract,
    DepreciationModuleName,
    changeJournalModuleName,
  ]).constant("depreciationCalculationType", ["Straight Line", "Double Declining Balance", "Sum Of The Years Digits"])
  .config(routeConfig)
  .component(MachinesComponentsViewsMainName, MachinesComponentsViewsMain)
  .component(
    MachineConfigurationViewComponentName,
    MachineConfigurationViewDetailComponentOptions
  )
  .service(CloneAndConversionServiceName, CloneAndConversionService)
  .component(machinesMoveViewComponentName, machinesMoveViewComponentOptions)
  .component(
    machinesWarehouseMoveViewComponentName,
    machinesWarehouseMoveViewComponentOptions
  )
  .component(
    machinesDecommissionMoveViewComponentName,
    machinesDecommissionMoveViewComponentOptions
  )
  .component(singleMachineMoveComponentName, singleMachineMoveComponentOptions)
  .component(
    singleMachineWarehouseComponentName,
    singleMachineWarehouseComponentOptions
  )
  .component(
    singleMachineDecommissionComponentName,
    singleMachineDecommissionComponentOptions
  )
  .component(
    machineDetailSpecificComponentName,
    machineDetailSpecificComponentOptions
  )
  .component(
    MachineConfigurationTypeDetailViewComponentName,
    MachineConfigurationTypeDetailViewComponentOptions
  )
  .component(
    machineConfigurationTypeInfoComponentName,
    machineConfigurationTypeInfoComponentOptions
  )
  .service(SlotTrakServerAdapterName, SlotTrakServerAdapter)
  .component(
    machineConfigurationTypeInfoGamesComponentName,
    machineConfigurationTypeInfoGamesComponentOptions
  )
  .component(
    machineConfigurationTypeDetailGameViewComponentName,
    machineConfigurationTypeDetailGameViewComponentOptions
  )
  .component(
    machineConfigurationTypeInfoProgressiveGamesComponentName,
    machineConfigurationTypeInfoProgressiveGamesComponentOptions
  )
  .component(
    machineProgressiveGameDetailViewComponentName,
    machineProgressiveGameDetailViewComponentOptions
  )
  .service(GratonUtilsServiceName, GratonUtilsService);
